var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotRatings4HalfstarRgb = function SvgTrustpilotRatings4HalfstarRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 18,
    viewBox: "0 0 91 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4halfstar-RGB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.559.023H18v16.801H.559Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4halfstar-RGB_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 .023h18v16.801H18Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4halfstar-RGB_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 .023h18v16.801H36Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4halfstar-RGB_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 .023h17v16.801H55Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4halfstar-RGB_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 .023h8.965v16.801H81Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_4halfstar-RGB_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73 .023h9v16.801h-9Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4halfstar-RGB_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M17.324.023H.56v16.801h16.765Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4halfstar-RGB_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M35.484.023H18.72v16.801h16.765Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4halfstar-RGB_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M53.645.023H36.879v16.801h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4halfstar-RGB_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M71.805.023H55.039v16.801h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4halfstar-RGB_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M89.965.023h-8.383v16.801h8.383Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_4halfstar-RGB_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M81.582.023h-8.383v16.801h8.383Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m8.941 11.348 2.551-.649 1.063 3.29Zm5.868-4.254H10.32L8.941 2.859 7.562 7.094H3.074l3.633 2.625-1.379 4.234 3.629-2.625 2.238-1.61ZM27.102 11.348l2.55-.649 1.063 3.29Zm5.867-4.254H28.48l-1.378-4.235-1.38 4.235h-4.488l3.633 2.625-1.379 4.234 3.63-2.625 2.237-1.61ZM45.262 11.348l2.55-.649 1.063 3.29Zm5.867-4.254H46.64l-1.38-4.235-1.378 4.235h-4.488l3.632 2.625-1.379 4.234 3.63-2.625 2.238-1.61ZM63.422 11.348l2.55-.649 1.063 3.29Zm5.867-4.254h-4.488l-1.38-4.235-1.378 4.235h-4.488l3.633 2.625-1.38 4.234 3.63-2.625 2.238-1.61ZM81.582 11.348l2.55-.649 1.063 3.29Zm5.867-4.254h-4.488l-1.379-4.235-1.379 4.235h-4.488l3.633 2.625-1.38 4.234 3.63-2.625 2.238-1.61Zm0 0"
  }));
};
export default SvgTrustpilotRatings4HalfstarRgb;